/**
 * Proly brand mark — a gradient rounded square with a white "P", matching the
 * app favicon (`src/app/icon.svg`). Self-contained (inline styles) so it can be
 * dropped anywhere: login, app shell, inside pages.
 */
export function ProlyMark({
  size = 36,
  radius,
  className = "",
}: {
  size?: number;
  radius?: number;
  className?: string;
}) {
  const r = radius ?? Math.round(size * 0.28);
  return (
    <span
      aria-hidden
      className={`inline-grid shrink-0 place-items-center ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: r,
        background: "linear-gradient(150deg, #5a78ff 0%, #2f49e0 58%, #6d4bff 100%)",
        color: "#fff",
        fontWeight: 700,
        fontSize: Math.round(size * 0.58),
        lineHeight: 1,
        letterSpacing: "-0.02em",
        boxShadow:
          "0 6px 16px -6px rgba(50, 73, 224, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.4)",
      }}
    >
      P
    </span>
  );
}
